// Google Tag Manager bootstrap, matching the legacy Razor Pages site's exact snippet.
// The bootstrap script itself is marked cookie-consent="strictly-necessary" so
// CookieFirst's scanner allows it to run without waiting for consent (GTM does
// not set cookies itself; tags configured inside it are gated separately via
// Google Consent Mode, configured in the GTM/CookieFirst dashboards).

export function pushDataLayer(data: Record<string, unknown>): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}

export function initGtm(gtmId: string): void {
    if (!gtmId) {
        return;
    }

    if (document.querySelector(`script[data-gtm-id="${gtmId}"]`)) {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    const script = document.createElement('script');
    script.setAttribute('cookie-consent', 'strictly-necessary');
    script.setAttribute('data-gtm-id', gtmId);
    script.text =
        "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
        "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
        "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
        "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
        `})(window,document,'script','dataLayer','${gtmId}');`;

    document.head.appendChild(script);
}

export function initGtmNoscriptFallback(gtmId: string): void {
    if (!gtmId) {
        return;
    }

    if (document.querySelector(`noscript[data-gtm-id="${gtmId}"]`)) {
        return;
    }

    // index.html is shared across all tenants (single build, multiple custom
    // domains), so this fallback can't be statically authored per-tenant and
    // must be inserted dynamically. Since the whole app is a JS-rendered SPA,
    // this <noscript> providing no benefit to genuinely JS-disabled users is
    // an accepted trade-off (the rest of the app wouldn't render either).
    const noscript = document.createElement('noscript');
    noscript.setAttribute('data-gtm-id', gtmId);

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
}
